export default class CustomTableController {

	readValue (header, line) {
		return this.applyFormatter(header.formatter, line[header.key]);
	}

	applyFormatter (formatter, value) {
		return formatter ? formatter(value) : value;
	}

	roundDecimals(number){
		return parseFloat(number).toFixed(2);
	}

	roundNumber(number){
		return Math.round(parseFloat(number));
	}

}

CustomTableController.$inject = [];



// WEBPACK FOOTER //
// ./src/directive/custom-table/custom-table.controller.js